import ContactPage from 'screens/Contact/Contact';

export default ContactPage;
